import { PageLayout } from "@/shared/ui/layouts/PageLayout";
import * as React from "react";

import { MortgageSection } from "../../../widgets/mortgage_section/ui";
import { useScrollToTop } from "@/shared/hooks/useScrollToTop";
import { useAppSelector } from "@/app/store/hooks";
import { useParams } from "react-router-dom";
import { ProjectMainSection } from "./section/ProjectMainSection";
import { selectAllProjects, selectProjectById } from "@/entities/projects/model/selects";
import { AboutSection } from "./section/AboutSection";
import { ViewApplicationSection } from "./section/ViewApplicationSection";
import { ProjectQualitySection } from "./section/ProjectQualitySection";
import { ProjectSliderSection } from "./section/ProjectSliderSection";
import { ProjectPlanSection } from "./section/ProjectPlanSection";
import { ProjectMapSection } from "./section/ProjectMapSection";
import { GetPresentationSection } from "./section/GetPresentationSection";

export function ProgectPage() {
    const { id } = useParams();
    const scrollToTop = useScrollToTop();

    const project = useAppSelector((state) =>
        id ? selectProjectById(id)(state) : undefined
    );

    const projects = useAppSelector(selectAllProjects);

    React.useEffect(() => {
        scrollToTop();
    }, [scrollToTop]);

    if (!project) return null;

    return (
        <PageLayout>
            <ProjectMainSection 
                name={project.title}
                title={project.subtitle} 
                presentation={project.presentation.link} 
                bg={project.imageUrl}
            />

            <AboutSection
                description={project.description}
                area={project.spec.areaFrom}
                complated={project.completionDate}
                floors={project.spec.floor}
                images={project.images}
                price={project.priceFrom}   
            />

            <ViewApplicationSection/>

            <ProjectQualitySection
                features={project.features}
            />

            <ProjectPlanSection
                planning={project.planning}
            />

            <ProjectMapSection
                project={project}
            />

            <GetPresentationSection 
                imageUrl={project.imageUrl}
                presentation={project.presentation}
            />

            <MortgageSection />

            <ProjectSliderSection
                projects={projects}
            />
        </PageLayout>
    );
}
